import React from "react";
import { Wrapper } from "../../components/Wrapper";
import { PageTitle } from "../../components/PageTitle";
import { Notification } from "../../utils/Notification";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Preload } from "../../components/Preload";
import { CityFormComponent } from "../../components/forms/CityFormComponent";
import { useQuery } from "@apollo/client";
import { GET_CITY } from "../../graphql/Queries/CityQuery";
import i18next from "i18next";

export const CityForm = ({ url }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  const { data } = useQuery(GET_CITY, {
    variables: {
      id: Number(searchParams.get("id")),
      lang: i18next.language,
    },
    fetchPolicy: "no-cache",
  });

  if (!data) {
    return <Preload />;
  }

  return (
    <Wrapper>
      <PageTitle
        title={
          searchParams.get("id") === null
            ? "Добавить город"
            : "Редактировать город"
        }
        breadcrumbs={[
          {
            slug: url,
            name: "Города",
          },
        ]}
      />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <CityFormComponent
                onSuccess={() => {
                  navigate(url);
                  Notification(t("Элемент добавлен"), "success");
                }}
                onError={(error) => Notification(error)}
                url={url}
                data={data}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
